/**
 * FeatureStatsBar — the window footer: total / enabled / whitelisted counts
 * plus a mode indicator dot. Extracted from FeatureManagerWindow.
 */
import React from 'react';
import { COLORS, SPACE, FONT_SIZE } from '../../theme';
import { FeatureMode } from '../../../../core/features';
import { modeColor } from './featureManagerStyles';

export interface FeatureStatsBarProps {
  total: number;
  enabled: number;
  whitelisted: number;
  currentMode: FeatureMode;
}

const barStyle: React.CSSProperties = {
  padding: `${SPACE.lg}px ${SPACE.xxl}px`,
  borderTop: `1px solid ${COLORS.borderSubtle}`,
  display: 'flex',
  gap: SPACE.xxxl,
  fontSize: FONT_SIZE.md,
  color: COLORS.textMuted,
};

const statStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: SPACE.sm,
};

export const FeatureStatsBar: React.FC<FeatureStatsBarProps> = ({
  total,
  enabled,
  whitelisted,
  currentMode,
}) => {
  return (
    <div style={barStyle}>
      <div style={statStyle}>
        <span>📊</span>
        <span>{total} total features</span>
      </div>
      <div style={statStyle}>
        <span>✓</span>
        <span>{enabled} enabled</span>
      </div>
      <div style={statStyle}>
        <span>🧪</span>
        <span>{whitelisted} whitelisted</span>
      </div>
      <div style={{ marginLeft: 'auto', ...statStyle }}>
        <span
          style={{
            width: 8,
            height: 8,
            borderRadius: '50%',
            background: modeColor(currentMode),
          }}
        />
        <span>{currentMode} mode</span>
      </div>
    </div>
  );
};
